import router from '@/router';

const LOSC_ALLOWED_ROLES = ['coApplicant'];

const appStarted = (store) => {
  const { externalId, role, hasCoApplicant, status, carhp } = router.currentRoute.query;

  if (router.currentRoute.query.role && !LOSC_ALLOWED_ROLES.includes(router.currentRoute.query.role)) {
    router.replace({
      ...router.currentRoute,
      query: {
        ...router.currentRoute.query,
        role: undefined,
      },
    });
  }

  if (router.currentRoute.name === 'callbackSigning') {
    // Handle Signicat callback
    store.dispatch('signing/handleSignicatCallback', {
      externalId,
      role,
      hasCoApplicant,
      status,
      carhp,
    }, { root: true });
  } else if (externalId) {
    // Attempt to continue if externalId exists in query
    store.dispatch('processStep/continueProcess', externalId, { root: true });
  }
};

export default { appStarted };
